import { Button, Drawer } from "antd";
import { FC, useState } from "react";
import * as Icons from '@ant-design/icons';
import ProductForm from "../forms/product-form";

interface Props {
    id: string,
    onEdit?: () => void,
}

const ProductDrower: FC<any> = ({ id, onEdit }: Props) => {
    const [open, setOpen] = useState(false)

    return (
        <>
            <Icons.EditTwoTone
                style={{ fontSize: "18px" }}
                onClick={() => setOpen(true)} >
            </Icons.EditTwoTone>
            <Drawer title="ویرایش محصول" placement="left" width={378 * 2}
                onClose={() => setOpen(false)} visible={open} >
                <ProductForm id={id} onEdit={onEdit} />
            </Drawer>
        </>
    )
}

export default ProductDrower
